import { useTranslation } from "react-i18next"
import { Tab, Tabs } from "@mui/material"

import type {
  DeviceInstallationTabsCounts,
  InstallationTab,
} from "helpers/hooks/devices/useDeviceInstallationTabs"

interface DeviceInstallationTabButtonsProps {
  activeTab: InstallationTab
  setActiveTab: (tab: InstallationTab) => void
  counts: DeviceInstallationTabsCounts
}

const DeviceInstallationTabButtons = ({
  activeTab,
  setActiveTab,
  counts,
}: DeviceInstallationTabButtonsProps) => {
  const { t } = useTranslation()
  const tabSx = { textTransform: "none" }

  return (
    <Tabs value={activeTab} onChange={(_, val: InstallationTab) => setActiveTab(val)}>
      <Tab
        value="installed"
        sx={tabSx}
        label={`${t("device_installation.DEVICES_INSTALLED")}: ${counts.installed}`}
      />
      <Tab
        value="notInstalled"
        sx={tabSx}
        label={`${t("device_installation.DEVICES_NOT_INSTALLED")}: ${counts.notInstalled}`}
      />
      <Tab value="all" sx={tabSx} label={`${t("table.ALL")}: ${counts.all}`} />
    </Tabs>
  )
}

export default DeviceInstallationTabButtons
